import Accordion from './accordion.element.js';

export default Accordion;

Accordion.define('wje-accordion', Accordion);
